var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.934673 5.46878C0.881645 5.02646 0.855131 4.80529 0.89242 4.62425C0.998829 4.10761 1.45333 3.68869 2.05903 3.54896C2.27129 3.5 2.53775 3.5 3.07068 3.5H12.9293C13.4622 3.5 13.7287 3.5 13.941 3.54896C14.5467 3.68869 15.0012 4.10761 15.1076 4.62425C15.1449 4.80529 15.1184 5.02646 15.0653 5.46878C14.9438 6.48252 14.3743 7.03704 13.2884 7.35673L10.16 8.27773C9.09058 8.59258 8.55585 8.75 8 8.75C7.44415 8.75 6.90942 8.59258 5.83997 8.27773L2.71161 7.35673C1.62571 7.03704 1.0562 6.48252 0.934673 5.46878Z",
    stroke: "#253837",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.59712 6.875L1.44994 8.58178C1.18611 11.6413 1.05419 13.171 1.90051 14.148C2.74682 15.125 4.20388 15.125 7.11801 15.125H8.88199C11.7961 15.125 13.2532 15.125 14.0995 14.148C14.9458 13.171 14.8139 11.6413 14.5501 8.58179L14.4029 6.875",
    stroke: "#253837",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 3.125L10.5671 2.92632C10.2783 1.93629 10.1339 1.44127 9.79019 1.15814C9.44646 0.875 8.98989 0.875 8.07676 0.875H7.92324C7.01011 0.875 6.55354 0.875 6.20981 1.15814C5.86609 1.44127 5.72171 1.93629 5.43295 2.92632L5.375 3.125",
    stroke: "#253837",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeSvg);
export default __webpack_public_path__ + "static/media/employeSVG.c7e265073541b4939cc0ddd08958eaef.svg";
export { ForwardRef as ReactComponent };